var render = function render(_c,_vm){return _c('b-jumbotron',{attrs:{"header":"Resource Not Found","lead":"There was an issue retrieving information on the resource you were looking for."}},[_c('b-btn',{attrs:{"href":"/"}},[_vm._v("Go To Dashboard")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }